import _extends from '@babel/runtime-corejs3/helpers/extends';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default from 'react';
import classNames from 'classnames';
import styles from '../9837bffb195015a4513e93472fb398acea449d84d98f6268afd87828b663e6c1.cfe-internal.js';
import MenuItem from './e0e3eb84541b87de3d5450a4a2a9274df211ed818d3168ab6e8a7aeb42987979.cfe-internal.js';
import '../../../icons/index.es.js';
import ChevronRightIcon from '../../../icons/components/88a8116bd7f81fb87e1ae07d2c7a465dd4392543779b5970a2459038f6173e7a.cfe-internal.js';

var _excluded = ["label", "className"];
var SubmenuAnchor = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var label = _ref.label,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(MenuItem, _extends({
    "aria-haspopup": "menu",
    className: classNames(className, styles.subMenu),
    ref: ref
  }, rest), label, /*#__PURE__*/React__default.createElement(ChevronRightIcon, {
    className: styles.rightIcon,
    "aria-hidden": "true"
  }));
});

export { SubmenuAnchor as default };
